<template>
  <div>
    <b-modal
      id="modalTopup"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-header
      hide-footer
      :dialog-class="isKomcardUser && !isKomshipUser? 'custom-modal-topup' : ''"
      centered
      @shown="topupFieldFocus"
    >
      <p class="text-2xl text-center font-semibold my-1">
        Top Up Saldo
      </p>
      <b-form
        class="mb-1"
        @submit.prevent="!checkIsValid(nominalTopUp) || topUpBalance()"
      >
        <b-form-group>
          <label
            for="nominalTopUp"
            class="font-semibold"
          >Nominal</label>
          <b-form-input
            id="nominalTopUp"
            v-model="nominalTopUp"
            placeholder="minimal Rp10.000,-"
            :formatter="formatNumber"
          />
          <small
            v-if="intNominal(nominalTopUp) < 10000"
            class="text-danger"
          >*Minimal top up Rp 10.000</small>
        </b-form-group>
        <div
          v-show="isKomcardUser && !isKomshipUser"
          class="mb-1"
        >
          <div class="bg-[#DFF3FF] p-1">
            <div class="grid grid-cols-4  items-center">
              <div class="col-span-3 w-fit">
                <span class="flex items-center gap-1">
                  <span>
                    <img
                      width="26"
                      src="https://storage.googleapis.com/komerce/assets/logo/logo-komship-chat.svg"
                      alt="logo-komship"
                      srcset=""
                    ></span> <span class="font-semibold text-[16px] leading-none tracking-normal align-middle text-[#333333]">Stop Ribet Top Up, Yuk Pakai Komship!</span>
                </span>
                <span class="text-sm font-normal leading-none tracking-normal align-middle">
                  Bayangin Kamu pakai Komship sebagai agregator <br> pengiriman COD, saldo di KomPay akan terus terisi <br> otomatis.
                </span>
              </div>
              <div class="grid justify-start">
                <b-button
                  href="https://komship.id"
                  target="_blank"
                  size="sm"
                  class="text-nowrap"
                  variant="outline-primary"
                >
                  Coba Sekarang
                </b-button>
              </div>
            </div>
          </div>
        </div>
        <b-row>
          <b-col cols="6">
            <b-btn
              variant="outline-primary"
              block
              :disabled="loadingTopUp"
              @click="handleClose"
            >
              Batal
            </b-btn>
          </b-col>
          <b-col cols="6">
            <b-btn
              type="submit"
              variant="primary"
              block
              :disabled="!checkIsValid(nominalTopUp)"
            >
              <b-spinner
                v-if="loadingTopUp"
                class="mr-[6px]"
                small
              />
              Top Up Sekarang
            </b-btn>
          </b-col>
        </b-row>
      </b-form>
    </b-modal>
    <PaymentMethod
      :is-weekend="isWeekend"
      :is-loading="loadingTopUp"
      :message-topup="messageTopup"
      @methodSelected="methodSelected"
    />
    <ScanQRIS
      :qr-bill-detail="qrBillDetail"
      @cancelPayment="cancelPayment"
      @paymentSuccess="paymentSuccess"
      @hidden="qrBillDetail = {}"
    />
    <ModalPaymentExist
      @continuePayment="continuePayment"
      @cancelPayment="cancelPayment"
    />
    <ModalTransferConfirm
      :transaction-date="transactionDate"
      :nominal="nominalLabel"
      :data-bill-exist="dataBillExist"
      @onSuccess="bankTopupSuccess"
      @onCancel="toastSuccess('Berhasil membatalkan pembayaran')"
    />
    <ModalSuccessTopup
      :transaction-date="transactionDate"
      :nominal="nominalLabel"
    />
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import moment from 'moment'
import { IDR } from '@/libs/currency'
import { FULL_DATE_TIME } from '@/libs/formatDate'
import ScanQRIS from '../../komship/dashboard/modal/ScanQRIS.vue'
import PaymentMethod from '../../komship/dashboard/modal/PaymentMethod.vue'
import ModalPaymentExist from '../../komship/dashboard/modal/ModalPaymentExist.vue'
import ModalSuccessTopup from './ModalSuccessTopup.vue'
import ModalTransferConfirm from './ModalTransferConfirm.vue'

export default {
  components: {
    PaymentMethod, ScanQRIS, ModalPaymentExist, ModalSuccessTopup, ModalTransferConfirm,
  },
  props: {
    dataBillExist: {
      type: Object || null,
      default: null,
    },
    beginTopup: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      IDR,
      loadingTopUp: false,
      qrBillDetail: {},
      isWeekend: false,
      messageTopup: '',
      isKomcardUser: this.$store.state.dashboard.profile.is_komcards === 1,
      isKomshipUser: this.$store.state.dashboard.profile.is_komship === 1,
      transactionDate: { date: '', time: '' },
      nominalLabel: '',
    }
  },
  computed: {
    ...mapFields('saldo', ['nominalTopUp']),
  },
  watch: {
    beginTopup(value) {
      if (value) {
        this.handleTopup()
      }
    },
  },
  methods: {
    intNominal(value) {
      if (!value) return 0
      return +value.replace(/\D/g, '')
    },
    formatNumber(value) {
      const result = this.intNominal(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
      return `Rp ${result}`
    },
    topupFieldFocus() {
      const field = document.getElementById('nominalTopUp')
      if (field) setTimeout(() => { field.focus() }, 100)
    },
    setTransactionData(nominal) {
      const date = new Date()
      const [dateLabel, timeLabel] = FULL_DATE_TIME(date).split(' - ')
      this.transactionDate.date = dateLabel
      this.transactionDate.time = timeLabel
      this.nominalLabel = nominal
    },
    async handleTopup() {
      this.$emit('update:loading', true)
      try {
        const { data: { data } } = await this.$store.dispatch('saldo/checkActiveBill')
        this.$emit('showTopupModal')
        if (data.have_active_bill) {
          this.$emit('update:dataBillExist', data)
          this.$emit('update:beginTopup', false)
          this.setTransactionData(!data.invoice_xendit_url ? IDR(data.qr_amount) : IDR(data.invoice_amount - data.admin_fee))
          this.$bvModal.show('modalPaymentExist')
          return
        }
        this.nominalTopUp = 'Rp 0'
        this.$bvModal.show('modalTopup')
      } catch (e) {
        this.$emit('update:beginTopup', false)
        this.$swal({
          title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
          text: e.message,
          imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
          confirmButtonText: 'Oke',
          confirmButtonClass: 'btn btn-primary',
        })
      } finally {
        this.$emit('update:loading', false)
      }
    },
    async topUpBalance() {
      if (this.intNominal(this.nominalTopUp) > 500000) {
        this.loadingTopUp = true
        try {
          const response = await this.$store.dispatch('saldo/newTopUpSaldo')
          const { data } = response
          if (!data.status) throw data
          try {
            this.setTransactionData(this.nominalTopUp)
            window.open(data.data.invoice_url, '_blank').focus()
            this.$bvModal.show('transfer-confirmation')
          } catch (e) {
            this.toastFailed('Pop-up Blocker diaktifkan! Harap tambahkan situs ini ke daftar pengecualian Anda.')
          } finally {
            this.$bvModal.hide('modalTopup')
            this.$emit('update:beginTopup', false)
            this.loadingTopUp = false
          }
        } catch (e) {
          this.$swal({
            title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
            text: e.message,
            imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        } finally {
          this.$bvModal.hide('modalTopup')
          this.$emit('update:beginTopup', false)
          this.loadingTopUp = false
          this.$store.commit('saldo/UPDATE_NOMINAL', '')
        }
      } else {
        this.getWeekend()
        this.$bvModal.show('paymentMethod')
      }
    },
    getWeekend() {
      const day = moment().day() // 0 = Minggu, 1 = Senin, ..., 6 = Sabtu
      const today = moment()
      const month = today.month() + 1 // Bulan sekarang (1-12)
      const todayDate = today.date() // Tanggal hari ini (1-31)
      const holidays = {
        1: ['27', '29'],
        3: ['31'],
        5: ['12'],
        6: ['9', '30'],
      }

      // ** Kondisi 2: Validasi Tanggal Merah **
      const currentHolidays = holidays[month] ? holidays[month].map(date => moment(`${month}-${date}`, 'M-D')) : []
      const holidayMatch = currentHolidays?.find(holiday => holiday.isSame(today, 'day'))

      this.isWeekend = (day >= 4 && day <= 6) || holidayMatch || (todayDate >= 1 && todayDate <= 7)

      if (todayDate >= 1 && todayDate <= 7) {
        // Kondisi tambahan jika today adalah tanggal 1 - 7
        this.messageTopup = `1 - 7 ${today.format('MMMM YYYY')}`
      } else if (day >= 4 && day <= 6) { // Kamis (4), Jumat (5), Sabtu (6)
        const startOfWeek = today.clone().startOf('isoWeek').add(3, 'days')
        const endOfWeek = today.clone().startOf('isoWeek').add(5, 'days')
        this.messageTopup = `${startOfWeek.format('D')} - ${endOfWeek.format('D MMMM YYYY')}`
      } else if (holidayMatch) {
        const twoDaysBefore = holidayMatch.clone().subtract(2, 'days')
        this.messageTopup = `${twoDaysBefore.format('D')} - ${holidayMatch.format('D MMMM YYYY')}`
      } else {
        this.messageTopup = 'tidak ada biaya admin'
      }
    },
    toastFailed(text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Failed',
          icon: 'AlertCircleIcon',
          text,
          variant: 'danger',
        },
      }, 2000)
    },
    toastSuccess(text) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Success',
          icon: 'SuccessIcon',
          text,
          variant: 'success',
        },
      }, 1000)
    },
    checkIsValid(nominalTopUp) {
      const invalid = this.intNominal(nominalTopUp) < 10000 || this.loadingTopUp
      return !invalid
    },
    handleClose() {
      this.$bvModal.hide('modalTopup')
      this.$emit('update:beginTopup', false)
      this.$emit('closeTopupModal')
    },
    async methodSelected(method) {
      this.loadingTopUp = true
      this.setTransactionData(this.nominalTopUp)

      if (method === 'qris' && !this.isWeekend) {
        try {
          const response = await this.$store.dispatch('saldo/qrisTopup')
          const { data } = response
          if (!data.status) throw data
          if (data.data) {
            const {
              amount,
              expires_at,
              qr_string,
              id,
            } = data.data
            this.qrBillDetail = {
              amount,
              expire: expires_at,
              qrString: qr_string,
              qrId: id,
            }
            this.$bvModal.hide('modalTopup')
            this.$emit('update:beginTopup', false)
            this.$bvModal.show('scanQris')
          }
        } catch (e) {
          this.$swal({
            title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
            text: e.message,
            imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        }
      }
      if (method === 'bank') {
        try {
          const response = await this.$store.dispatch('saldo/newTopUpSaldo', true)
          const { data } = response
          this.$emit('update:dataBillExist', { invoice_xendit_id: data.data.id })
          if (!data.status) throw data
          try {
            window.open(data.data.invoice_url, '_blank').focus()
            this.$bvModal.show('transfer-confirmation')
          } catch (e) {
            this.toastFailed('Pop-up Blocker diaktifkan! Harap tambahkan situs ini ke daftar pengecualian Anda.')
          } finally {
            this.$bvModal.hide('modalTopup')
            this.$emit('update:beginTopup', false)
          }
        } catch (e) {
          this.$swal({
            title: '<span class="font-semibold h4">Top Up Saldo Gagal</span>',
            text: e.message,
            imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
            confirmButtonText: 'Oke',
            confirmButtonClass: 'btn btn-primary',
          })
        } finally {
          this.$store.commit('saldo/UPDATE_NOMINAL', '')
        }
      }
      this.loadingTopUp = false
      this.$bvModal.hide('paymentMethod')
    },
    continuePayment() {
      this.$bvModal.hide('modalPaymentExist')
      if (!this.dataBillExist.invoice_xendit_url) {
        const {
          qr_amount,
          qr_expire_date,
          qr_xendit_qrstring,
          qr_xendit_id,
        } = this.dataBillExist

        this.qrBillDetail = {
          amount: qr_amount,
          expire: qr_expire_date,
          qrString: qr_xendit_qrstring,
          qrId: qr_xendit_id,
        }

        this.$bvModal.show('scanQris')
        return
      }
      try {
        window.open(this.dataBillExist.invoice_xendit_url, '_blank').focus()
        this.$bvModal.hide('modalTopup')
        this.$emit('update:beginTopup', false)
        this.$bvModal.show('transfer-confirmation')
      } catch (e) {
        this.toastFailed('Pop-up Blocker diaktifkan! Harap tambahkan situs ini ke daftar pengecualian Anda.')
      }
    },
    async cancelPayment(qr) {
      try {
        let response
        if (!qr && this.dataBillExist.invoice_xendit_id) {
          response = await this.$store.dispatch('saldo/cancelActiveBill', this.dataBillExist.invoice_xendit_id)
        } else {
          response = await this.$store.dispatch('saldo/cancelQrBill', qr || this.dataBillExist.qr_xendit_id)
        }
        const { data } = response
        if (data.code === 200) {
          this.toastSuccess('Berhasil membatalkan pembayaran')

          this.$bvModal.hide('modalPaymentExist')
          this.$bvModal.hide('scanQris')
          this.$bvModal.hide('modalTopup')
          this.$emit('update:beginTopup', false)
          this.loadingTopUp = false
        }
        if (!data.status) throw data
      } catch ({ response }) {
        if (response.status === 400 || (response.status === 404 && response.data.data.detail === 'could not find invoice by id')) {
          this.toastSuccess('Pembayaran sudah berhasil dilakukan')
          this.$bvModal.hide('modalPaymentExist')
          this.$store.dispatch('dashboard/getBalanceSummary')
          return
        }
        this.$swal({
          title: '<span class="font-semibold h4">Pembatalan Pembayaran Gagal</span>',
          text: response.data.data,
          imageUrl: 'https://storage.googleapis.com/komerce/assets/icons/fail.svg',
          confirmButtonText: 'Oke',
          confirmButtonClass: 'btn btn-primary',
        })
      }
    },
    paymentSuccess() {
      this.$store.dispatch('dashboard/getBalanceSummary')
      this.$bvModal.hide('scanQris')
      this.$bvModal.hide('modalPaymentExist')
      this.loadingTopUp = false
      this.$bvModal.hide('modalTopup')

      this.$bvModal.show('success-topup')
      this.$emit('update:beginTopup', false)
    },
    bankTopupSuccess() {
      this.$store.dispatch('dashboard/getBalanceSummary')
      this.$bvModal.show('success-topup')
    },
  },
}
</script>
